<template>
    <div>
        <div class="location__select-wrap"
             ref="location-select-wrap"
             @blur.capture="deferHideRegionList"
             @keyup.esc="$event.target.blur()"
             @keydown.up.prevent="arrowsToggleFocus"
             @keydown.down.prevent="arrowsToggleFocus"
             @keydown.tab="tabToggleFocus">

            <div class="location__select form-control"
                 :class="selected_item ? 'selected' : ''"
                 @click="openList">
                {{ selected_item ? selected_item[title_key] : placeholder || '' }}
            </div>
            <div class="location__dropped-ui"
                 v-show="list_visibility">
                <input ref="list-filter"
                       type="text"
                       class="location__list-filter"
                       autocomplete="seriously-off"
                       v-model="search_string">

                <ul class="location__list list-unstyled">
                    <li class="location__item"
                        tabindex="0"
                        v-for="item in filtered_items"
                        :class="(selected_item && selected_item[value_key] === item[value_key]) ? 'current-item' : ''"
                        @click="setItem(item)"
                        @keydown.enter.prevent="setItem(item)">
                        {{ item[title_key] }}
                    </li>
                </ul>
            </div>
        </div>

        <input type="hidden" :name="name" :value="selected">
    </div>
</template>

<script>
    import keyboardFocusControl from '../mixins/keyboardFocusControl.js';
    
    export default {
        mixins: [keyboardFocusControl],
        props: [
            'items',
            'selected',
            'name',
            'value_key',
            'title_key',
            'placeholder'
        ],
        data () {
            return {
                search_string: '',
                list_visibility: false,
            }
        },
        computed: {
            filtered_items() {
                return this.filterItems(this.items);
            },
            selected_item() {
                if (this.selected !== null) {
                    return this.items.find((item) => {
                        return item[this.value_key] === this.selected;
                    });
                }

                return null;
            }
        },
        methods: {
            openList () {
                this.list_visibility = true;
                this.$nextTick(() => {
                    this.$refs['list-filter'].focus();
                });
            },
            setItem (item) {
                this.list_visibility = false;
                
                this.$emit('selected', item)
            },
            filterItems(items) {
                return items.filter((location) => {
                    let query = this.search_string.toLowerCase();
                    let itemName = location[this.title_key].toLowerCase();
                    
                    return itemName.indexOf(query) >= 0;
                });
            },
            deferHideRegionList () {
                requestAnimationFrame(() => {
                    let parentRegionElement = this.$refs['location-select-wrap'];
                    if (!parentRegionElement.contains(document.activeElement)) {
                        this.list_visibility = false;
                    }
                });
            }
        },
    };
</script>
